import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeM from '../views/gb/mobile.vue'
import Home from '../views/home.vue'
import path from 'path'
// import UAParser from 'ua-parser-js';
// const uaParser = new UAParser();
// const deviceInfo = uaParser.getResult();

// const isMobileDevice = deviceInfo.device.type === 'mobile';
Vue.use(VueRouter)

/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 开始 */
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}
/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 结束 */

export const constRoutesPc = [
	{
		path: '/',
		name: 'en-gb',
		meta: {
			appname: 'GBWhatsApp',
			title: `Download GB WhatsApp APK 2026 - Latest Version v18.70`,
			keywords: 'gbwhatsapp, gb whatsapp, gb whatsapp apk, gb whatsapp download',
			description: `Download GB WhatsApp APK new updated 2026 for Android in this safe site. GBWhatsApp is a MOD version based on WhatsApp with extra unlocked features.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwhataps.com/'
				}
			]
		},
		component: Home,
	},
	{
		path: '/download',
		name: 'en-download',
		meta: {
			appname: 'GBWhatsApp',
			title: `Download Page of GB WhatsApp APK 2026`,
			keywords: 'gbwhatsapp apk download, gb whatsapp apk download, gbwhatsapp download, gb whatsapp download',
			description: `Get the latest version of GB WhatsApp APK on this page. Enjoy enhanced features, customization, privacy options, and anti-ban support.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwhataps.com/download/'
				}
			]
		},
		component: () => import('@/views/download.vue'),
	},
	{
		path: '/gbwhatsapp-blog/',
		name: 'en-blogs',
		meta: {
			appname: 'GBWhatsApp',
			title: `GBWhatsApp Blog – Latest Tips, Updates, and How-To Guides`,
			keywords: 'gbwhatsapp tips, gbwhatsapp guide',
			description: `Explore the official GBWhatsApp Blog for the newest updates, tutorials, and expert tips. Learn how to use GBWhatsApp features, stay safe, and get the latest version updates in 2026.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwhataps.com/blog/'
				}
			]
		},
		component: () => import('@/views/blogs.vue'),
	},
	{
		path: '/fm-whatsapp/',
		name: 'en-fm-whatsapp',
		meta: {
			appname: 'GBWhatsApp',
			modKey: 'fm',
			title: 'Download FM WhatsApp for Android 2026 | Explore New Version',
			keywords: 'fm whatsapp, fm whatsapp vs gb whatsapp, fm whatsapp features',
			description: 'FM WhatsApp is a modified version of the official app. Download FMWhatsApp to explore more advanced features different from the official one.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwhataps.com/fm-whatsapp/'
				}
			]
		},
		component: () => import('@/views/mod-app.vue'),
	},
	{
		path: '/whatsapp-plus/',
		name: 'en-whatsapp-plus',
		meta: {
			appname: 'GBWhatsApp',
			modKey: 'plus',
			title: 'WhatsApp Plus APK v18.80 Download 2026 Updated',
			keywords: 'whatsapp plus, whatsapp plus vs gb whatsapp, whatsapp plus features',
			description: 'Get WhatsApp Plus v18.80 APK for Android and explore new themes, privacy settings, message controls, installation tips, updates, and common issues.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwhataps.com/whatsapp-plus/'
				}
			]
		},
		component: () => import('@/views/mod-app.vue'),
	},
	{
		path: '/yowhatsapp/',
		name: 'en-yowhatsapp',
		meta: {
			appname: 'GBWhatsApp',
			modKey: 'yowa',
			title: 'YoWhatsApp APK Latest Version Download 2026',
			keywords: 'yowhatsapp, yo whatsapp, yowhatsapp vs gb whatsapp',
			description: 'Download YoWhatsApp APK latest version, features. Explore YO WhatsApp Android compatibility, installation steps, safety risks, and alternatives.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwhataps.com/yowhatsapp/'
				}
			]
		},
		component: () => import('@/views/mod-app.vue'),
	},
	{
		path: '/og-whatsapp/',
		name: 'en-og-whatsapp',
		meta: {
			appname: 'GBWhatsApp',
			modKey: 'og',
			title: 'OG WhatsApp APK New Version Download for Android 2026',
			keywords: 'og whatsapp, og whatsapp vs gb whatsapp, og whatsapp features',
			description: 'Download OG WhatsApp APK for Android in 2026. Check the latest features, dual-account options, installation steps, updates, and safety details.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwhataps.com/og-whatsapp/'
				}
			]
		},
		component: () => import('@/views/mod-app.vue'),
	},
	{
		path: '/about-us',
		name: 'en-about-us',
		meta: {
			appname: 'GBWhatsApp',
			title: `About Us`,
			keywords: 'gbwhatsapp, gb whatsapp, about us, gbwhatsapp info',
			description: `Learn more about our website. We provide safe and reliable information of GB WhatsApp APK, but we are not the developers or affiliated with WhatsApp Inc.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwhataps.com/about-us/'
				}
			]
		},
		component: () => import('@/views/about-us.vue'),
	},
	{
		path: '/privacy-policy',
		name: 'en-privacy-policy',
		meta: {
			appname: 'GBWhatsApp',
			title: `Privacy Policy`,
			keywords: 'gbwhatsapp, gb whatsapp, privacy policy, gbwhatsapp privacy',
			description: `Read our Privacy Policy to understand how we collect, use, and protect your information while browsing our site.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwhataps.com/privacy-policy/'
				}
			]
		},
		component: () => import('@/views/privacy-policy.vue'),
	},
	{
		path: '/disclaimer',
		name: 'en-disclaimer',
		meta: {
			appname: 'GBWhatsApp',
			title: `Disclaimer`,
			keywords: 'gbwhatsapp, gb whatsapp, disclaimer, gbwhatsapp disclaimer',
			description: `Read our Disclaimer page to know about the disclaimer of gbwhatsapp site.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwhataps.com/disclaimer/'
				}
			]
		},
		component: () => import('@/views/disclaimer.vue'),
	},
	{
		path: '/setup-gbwhatsapp-guide/',
		name: 'en-blog-1',
		meta: {
			appname: 'GBWhatsApp',
			title: `Setting Up GBWhatsApp for Maximum Efficiency`,
			keywords: 'GBWhatsApp, GB WhatsApp setup, GB WhatsApp guide',
			description: `A simple, human guide to setting up GBWhatsApp right — faster chats, better privacy, and a look that actually feels like yours.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwhataps.com/setup-gbwhatsapp-guide/'
				}
			]
		},
		component: () => import('@/views/blog-1.vue'),
	},
	{
		path: '/the-secret-settings-that-make-gbwhatsapp-more-private-than-ever/',
		name: 'en-blog-2',
		meta: {
			appname: 'GBWhatsApp',
			title: `The Secret Settings That Make GBWhatsApp More Private Than Ever`,
			keywords: 'GBWhatsApp privacy, GBWhatsApp hidden settings, GBWhatsApp hide status',
			description: `Unlock hidden GBWhatsApp settings that enhance privacy, hide activity, and let you control who sees your chats and status.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwhataps.com/the-secret-settings-that-make-gbwhatsapp-more-private-than-ever/'
				}
			]
		},
		component: () => import('@/views/blog-2.vue'),
	},
	{
		path: '/how-to-lock-conversations-in-gbwhatsapp-without-interrupting-chat-flow/',
		name: 'en-blog-3',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Lock Conversations in GBWhatsApp Without Interrupting Chat Flow`,
			keywords: 'GBWhatsApp, lock conversations, privacy',
			description: `Learn how to secure your GBWhatsApp chats with the lock conversation feature while keeping messaging smooth and uninterrupted.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwhataps.com/how-to-lock-conversations-in-gbwhatsapp-without-interrupting-chat-flow/'
				}
			]
		},
		component: () => import('@/views/blog-3.vue'),
	},
	{
		path: '/hide-online-status-in-gbwhatsapp/',
		name: 'en-blog-4',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Hide Online Status in GBWhatsApp`,
			keywords: 'hide online status in gbwhatsapp',
			description: `In order to better protect personal privacy, GB WhatsApp lets you easily hide your online status without affecting your daily communication experience.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwhataps.com/hide-online-status-in-gbwhatsapp/'
				}
			]
		},
		component: () => import('@/views/blog-4.vue'),
	},
	{
		path: '/change-themes-gbwhatsapp/',
		name: 'en-blog-5',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Change Themes in GBWhatsApp`,
			keywords: 'change themes in GB WhatsApp',
			description: `Learn how to change and customize GBWhatsApp themes with step-by-step instructions. Discover theme installation methods, customization options, and troubleshooting tips.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwhataps.com/change-themes-gbwhatsapp/'
				}
			]
		},
		component: () => import('@/views/blog-5.vue'),
	},
	{
		path: '/how-to-fix-gbwhatsapp-not-installing/',
		name: 'en-blog-6',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Not Installing? How to Fix "App Not Installed"`,
			keywords: 'gb whatsapp not installing, gbwhatsapp app not installed, fix gbwhatsapp install error',
			description: `If you can't install GB WhatsApp, you can read the methods we provide to fix these bugs.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwhataps.com/how-to-fix-gbwhatsapp-not-installing/'
				}
			]
		},
		component: () => import('@/views/blog-6.vue'),
	},
	{
		path: '/save-gb-whatsapp-status/',
		name: 'en-blog-7',
		meta: {
			appname: 'GBWhatsApp',
			title: 'How to Save GB WhatsApp Status Photos and Videos',
			keywords: 'save gb whatsapp status, download gb whatsapp status, gb whatsapp status saver',
			description: 'Learn how to save GB WhatsApp Status photos and videos, find downloaded files on Android, and fix common saving problems.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwhataps.com/save-gb-whatsapp-status/'
				}
			]
		},
		component: () => import('@/views/blog-7.vue'),
	},
	{
		path: '/hide-typing-recording-status-gb-whatsapp/',
		name: 'en-blog-8',
		meta: {
			appname: 'GBWhatsApp',
			title: 'How to Hide Typing and Recording Status in GB WhatsApp',
			keywords: 'hide typing status gb whatsapp, hide recording status gb whatsapp, gb whatsapp privacy',
			description: 'Learn how to hide typing and recording indicators in GB WhatsApp, find the relevant privacy settings, and troubleshoot common issues.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gbwhataps.com/hide-typing-recording-status-gb-whatsapp/'
				}
			]
		},
		component: () => import('@/views/blog-8.vue'),
	},

]

// export const constRoutesM = [
// 	{
// 		path: '/',
// 		name: 'Home',
// 		meta: {
// 			appname: 'GBWhatsApp',
// 			topLogo: require('@/assets/gb/GB_new_icon_small@2x.png'),
// 			footLogo: require('@/assets/gb/icon_GB_new@2x.png'),
// 			showBreadcrumb: true,
// 			showTelegram: true,
// 		},
// 		// component: HomeM,
// 	},
// 	{
// 		path: '/download',
// 		name: 'download',
// 		meta: {
// 			appname: 'GBWhatsApp',
// 			topLogo: require('@/assets/gb/GB_new_icon_small@2x.png'),
// 			footLogo: require('@/assets/gb/icon_GB_new@2x.png'),
// 			showBreadcrumb: false,
// 		},
// 		component: () => import('@/components/download.vue'),
// 	},
// ]

let routes = []
// if (isMobileDevice) {
// 	routes = constRoutesM
// }
// if (!isMobileDevice) {
// 	routes = constRoutesPc
// }

routes = constRoutesPc
export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})
}
